import DefaultLayout from "@/components/layouts/DefaultLayout";
import CourseDetails from "@/components/views/CourseDetails";
import {
  getContentTypeBySlug,
  getSlugsForContentType,
} from "@/services/DefaultService";
import { ContentTypes } from "@/types/ContentTypes";
import { QueryClient, dehydrate } from "@tanstack/react-query";
import { GetStaticPaths, GetStaticProps, NextPage } from "next";
import NotFoundPage from "../404";

interface Props {
  course: any;
}

const Index: NextPage<Props> = ({ course }) => {
  if (!course) {
    return <NotFoundPage />;
  }

  return (
    <DefaultLayout seo={course.attributes.seo}>
      <CourseDetails course={course} />
    </DefaultLayout>
  );
};

export const getStaticPaths: GetStaticPaths = async () => {
  let paths = [];
  try {
    const slugs = await getSlugsForContentType(ContentTypes.COURSES);
    paths = slugs.map((slug: string) => ({
      params: { slug },
    }));
  } catch (err) {
  } finally {
    return {
      paths,
      fallback: "blocking",
    };
  }
};

export const getStaticProps: GetStaticProps = async (context) => {
  try {
    const slug = context.params?.slug as string;
    const data = await getContentTypeBySlug({
      contentType: "course",
      slug,
      populate: ["lessons", "image"],
    });

    return {
      props: {
        dehydratedState: dehydrate(new QueryClient()),
        course: data.data,
      },
    };
  } catch (err) {
    return {
      props: {
        course: null,
      },
    };
  }
};

export default Index;
